import HBEmpty from "@/components/HBEmpty";
import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import Image from "@/components/Image";
import { useLogin } from "@/components/LoginModal";
import { PinEditorModal } from "@/components/PinEditor";
import PurePinButton from "@/components/PurePinCard/actions/button";
import ShareDropdown from "@/components/ShareDropdown";
import SimilarMaterialList from "@/components/SimilarMaterialList";
import { EVENT } from "@/constants/event";
import {
  deletePin,
  getPin,
  getSimiliarMaterial,
  likePin,
  report,
  unlikePin,
} from "@/services";
import displayNum from "@/utils/displayNum";
import { ContentType, getContentType } from "@/utils/getContentType";
import usePngBg from "@/utils/hooks/usePngBg";
import imageUrl from "@/utils/imageUrl";
import isEditingElement from "@/utils/isEditingElement";
import { isFont } from "@/utils/pinMediaType";
import useRequest from "@/utils/useReq";
import { useKeyPress } from "ahooks";
import { Affix, Button, Modal } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import qs from "qs";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Case, Else, If, Switch, Then, When } from "react-if";
import FontDetailPreview from "./FontDetailPreview";
import styles from "./index.module.less";
import ModalOperate from "./ModalOperate";
import PinHead from "./PinHead";
import { PinMaterialRedirect } from "./PinMaterial";
// import PinMoreDropdown from "./PinMoreDropdown";
import { PIN_MATERIAL_STATUS } from "@/constants/pinMaterialStatus";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import { SHORTCUT } from "@/constants/shortcut";
import { isBigCompanyByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { addHistory } from "@/services/history";
import { isGdMerged } from "@/utils/gaoding";
import { isBigCompanyByGdVip } from "@/utils/gaodingVip";
import { gdSlsReportError } from "@/utils/gdSlsRum";
import getNextDetailsSetp, {
  getNextViewImageSetp,
} from "@/utils/getHistorySetp";
import {
  DIRECTION,
  useListenScrollDirection,
} from "@/utils/hooks/useListenScrollDirection";
import { PRESETS_CONDITION, stewardInstance } from "@/utils/steward";
import ReportModal from "../ReportModal";
// import PinDetailAiTools from "./AiTools";
import SimilarSearchButton from "@/components/SimilarSearchButton";
import { AB_PIN_SIMILAR } from "@/constants/ABMng";
import { PIN_PRIVATE_STATUS } from "@/constants/pin";
import { useSideNavWidth } from "@/context/useSideNavWidth";
import useABTest from "@/utils/hooks/useABtest";
import { useBoardMatching } from "@/utils/hooks/useBoardMatching";
import { useRelatedBoards } from "@/utils/hooks/useRelatedBoards";
import { getContainedImageSize } from "@/utils/img";
import { openBindTelModal } from "@/utils/open";
import dayjs from "dayjs";
import AiTag from "../AiTag";
import PurePinMore from "../PurePinCard/more";
import { ArtButton, NormalButton } from "./Full/Buttons";
import { PinAIInfo2 } from "./PinAIInfo";
import PinMaterial2 from "./PinMaterial2";
import { usePinDetailStore } from "./pinStore";
import PinTitle from "./PinTitle";
import RecommendNew from "./RecommendNew";
import PinSeries from "./Series";
import { usePinArtLink } from "./usePinArtLink";
import { usePinDetailPV } from "./usePinDetialPV";

import { usePinStackContext } from "./hooks/usePinStackContext";

const actionHeight = 64;

// 素材展示模块吸顶距离
const viewStickyTop = 48;
const viewPadding = 24;

const isMaterialPin = (pin) => {
  return (
    pin?.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE &&
    pin?.file_material?.material_category !== "其他" &&
    pin?.material_info &&
    pin?.material_info.err !== 404
  );
};

export default function PinDetail(props) {
  const router = useRouter();
  const {
    user,
    userReady,
    pinQueue,
    headerHeight,
    pinOpenType,
    currentPin = null,
    config,
    vips,
    pinStack,
  } = useAppStore(
    ({
      user,
      userReady,
      pinQueue,
      headerHeight,
      currentPin,
      pinOpenType,
      config,
      vips,
      pinStack,
    }) => ({
      user,
      userReady,
      pinQueue,
      headerHeight,
      currentPin,
      pinOpenType,
      config,
      vips,
      pinStack,
    })
  );
  const { login } = useLogin();
  const {
    pinId,
    pin: initPins,
    file,
    currentSrc,
    onClose,
    isModal,
    relatedBoards,
    searchWord: _searchWord,
    stackIndex = 0,
  } = props;
  const searchWord = _searchWord || router.query?.searchWord || router.query?.q;
  const [pin, setPin] = useState(initPins || currentPin);
  const [isRecommendVisible, setIsRecommendVisible] = useState(false);
  const { pushPinToStack } = useAppStore(({ pushPinToStack }) => ({
    pushPinToStack,
  }));

  // 使用 state 延迟 newPinId 更新，避免与 fileIds 更新时序不一致导致重复请求
  const [newPinId, setNewPinId] = useState(
    (pin?.pin_id || pinId)?.toString() || ""
  );

  // 延迟更新 newPinId，确保 fileIds 已经更新
  // 相似素材依赖fileIds和newPinId，但是他们更新时机是异步的，所以这块为了减少接口多次请求，需要延迟更新。
  // 这仅仅是个临时措施，根本上还是要解决一进入该组件就能保证获取到pinid和fileIds，以及下方pushPinToStack的入栈时机（旧版详情页）
  // TODO 优化 pinid和fileIds的获取时机
  useEffect(() => {
    const id = (pin?.pin_id || pinId)?.toString();
    if (id && id !== newPinId) {
      // 延迟更新，确保 fileIds 已经更新
      const timer = setTimeout(() => {
        setNewPinId(id);
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [pinId, pin?.pin_id, newPinId]);

  useEffect(() => {
    if (!pin?.pin_id) return;
    if (!isModal) return;

    // 入栈时添加标识：这是普通模态详情页
    pushPinToStack({
      ...pin,
      pinId: pin.pin_id,
      _timestamp: Date.now(),
    });
  }, [pin?.pin_id, isModal]);

  const { fileIds } = usePinStackContext();
  // 判断是否从发现页跳转
  const isFromDiscovery = useMemo(() => {
    return router.pathname === "/discovery";
  }, [router.pathname]);

  // 定义 recordOperation 函数（触发事件）
  const recordOperation = useCallback(
    (fileId, type) => {
      if (isFromDiscovery) {
        window.dispatchEvent(
          new CustomEvent(EVENT.INSPIRATION_WORDS_RECORD, {
            detail: {
              fileId,
              type,
              pageScope: "pin_recommend_word",
            },
          })
        );
      }
    },
    [isFromDiscovery]
  );

  // 获取同在画板信息
  const { getSingleRelatedBoards } = useRelatedBoards();
  const {
    getBoardMatchingForPin,
    ensureUserBoardsLoaded,
    userBoards,
    isNewUser,
    updateUserBoards,
  } = useBoardMatching();
  const [boardMatchingResult, setBoardMatchingResult] = useState({
    recommendedBoard: null,
    recommendedBoards: [],
    recommendedRelatedBoards: [],
    useUserBoardRecommendation: false,
  });

  const indexRef = useRef(0);
  const recommendRef = useRef(null);

  const style = {
    position: "sticky",
    top: `${isModal ? actionHeight : headerHeight + actionHeight}px`,
  };
  const stickyRef = useRef();
  const rightContent = useRef();
  const viewContentRef = useRef();

  const getParentTopDistance = (dom) => {
    if (!dom) {
      return;
    }
    // 获取到父元素顶部的距离
    const childTop = dom.getBoundingClientRect().top;
    const parentTop = dom.parentElement.getBoundingClientRect().top;
    return childTop - parentTop;
  };

  const viewUp = (preDirection) => {
    if (!viewContentRef.current) {
      return;
    }
    // 只有屏幕高度小于图片展示的时候才需要处理
    const needListen =
      window.innerHeight -
        viewContentRef.current.getBoundingClientRect().height -
        viewPadding <
      0;

    if (needListen) {
      const top = isModal ? viewStickyTop : headerHeight + viewStickyTop;

      const viewportTopDistance = Math.round(
        viewContentRef.current.getBoundingClientRect().top
      );

      // 满足条件吸顶
      if (viewportTopDistance >= top) {
        viewContentRef.current.style.position = "sticky";
        viewContentRef.current.style.top = `${top}px`;
        return;
      }
      const parentTopDistance = getParentTopDistance(viewContentRef.current);

      // 切换了滚动方向之后则允许滚动
      if (!preDirection || preDirection === DIRECTION.down) {
        // 距离视口底部距离
        viewContentRef.current.style.position = "relative";
        viewContentRef.current.style.top = `${parentTopDistance}px`;
      }
    }
  };

  const viewDown = (preDirection) => {
    if (!viewContentRef.current) {
      return;
    }

    const diffHeight =
      window.innerHeight -
      viewContentRef.current.getBoundingClientRect().height -
      viewPadding;

    // 只有屏幕高度小于图片展示的时候才需要处理
    if (diffHeight < 0) {
      // 距离视口底部距离
      const viewportBottomDistance = Math.round(
        window.innerHeight -
          viewContentRef.current.getBoundingClientRect().bottom
      );
      // 满足条件吸底
      if (viewportBottomDistance >= viewPadding) {
        viewContentRef.current.style.position = "sticky";
        viewContentRef.current.style.top = `${diffHeight}px`;
        return;
      }
      // 切换滚动方向则允许滚动
      if (!preDirection || preDirection === DIRECTION.up) {
        const parentTopDistance = getParentTopDistance(viewContentRef.current);
        viewContentRef.current.style.position = "relative";
        viewContentRef.current.style.top = `${parentTopDistance}px`;
      }
    }
  };
  useListenScrollDirection(
    // 向上滚动
    (preDirection) => {
      // rightContentUp(preDirection);
      viewUp(preDirection);
    },
    (preDirection) => {
      // rightContentDown(preDirection);
      viewDown(preDirection);
    },
    isModal ? () => document.querySelector(".pinDetailModal") : undefined
  );
  useEffect(() => {
    // 切换采集后重置滚动样式;
    if (viewContentRef.current) {
      viewContentRef.current.style.position = "sticky";
      viewContentRef.current.style.top = `${
        isModal ? viewStickyTop : headerHeight + viewStickyTop
      }px`;
    }
  }, [pinId, isModal, headerHeight]);
  // const previewModal = useRef(null); // 查看大图弹窗
  const detailRef = useRef(null);
  // const [offsetTop, setOffsetTop] = useState(0);
  const [notFoundPin, setNotFountPin] = useState(false);

  const pinFile = useMemo(() => {
    return file || pin?.file;
  }, [file, pin]);

  const initRef = useRef(true);

  useEffect(() => {
    if (getContentType(pin) === ContentType.material) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_MATERIAL_DETAILS_ENTER_TIMES,
        {
          needRemoveTrigger: true,
        }
      );
    }
  }, [pin]);

  // AB 实验：找相似按钮
  const abPinSimilar = useABTest(AB_PIN_SIMILAR);
  // new: 新按钮, old: 旧按钮
  const isNewSimilarButton = abPinSimilar.new;

  // 监听推荐列表可见性（仅在新版推荐和弹窗模式下）
  useEffect(() => {
    if (!isModal || !recommendRef.current) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsRecommendVisible(entry.isIntersecting);
        });
      },
      {
        threshold: 0.1, // 当推荐列表10%可见时触发
        rootMargin: "0px 0px -100px 0px", // 提前100px触发
      }
    );

    observer.observe(recommendRef.current);

    return () => {
      observer.disconnect();
    };
  }, [isModal, pin?.pin_id]);

  const { run: runReload } = useRequest(
    async () => {
      if (!pinId) {
        return;
      }

      // 服务端渲染第一次则没有必要重复请求数据
      if (initRef.current && initPins) {
        initRef.current = false;
        return;
      }

      const result = await getPin({
        pin_id: pinId,
        pins: 20,
        ignoreMessage: true,
        related_topic: "material",
      });

      const fetchedPin = result?.pin || null;

      if (result.err === 404) {
        if (isModal) {
          setNotFountPin(true);
        } else {
          router.push("/404", `/pins/${pinId}`);
        }
      } else if (!fetchedPin) {
        // 记录一下其他错误场景
        gdSlsReportError(result.msg || result.err);
      } else {
        setNotFountPin(false);

        setPin(fetchedPin);
        if (user) {
          addHistory({
            type: "pin",
            record: result?.pin,
            id: pinId,
          });
        }

        let { modalImg } = qs.parse(location.search.slice(1));
        if (modalImg) {
          const isMaterial = isMaterialPin(fetchedPin);
          let currentPreview = getCurrentPreview(
            fetchedPin,
            fetchedPin.file,
            user,
            isMaterial
          );
          useAppStore.setState({
            currentPreview,
          });
        }
      }
    },

    {
      refreshDeps: [pinId],
    }
  );

  const { runAsync: runDelete } = useRequest(deletePin, {
    manual: true,
  });
  const { runAsync: runLike } = useRequest(likePin, {
    manual: true,
  });
  const { runAsync: runUnlike } = useRequest(unlikePin, {
    manual: true,
  });

  // 获取相似素材列表
  const similiarList = useRequest(
    async () => {
      if (isBigCompany || isFont(pin)) {
        return {
          pins: [],
        };
      }
      return getSimiliarMaterial({
        pin_id: newPinId,
        source_context_file_id_str: fileIds.join(","),
        search_word: searchWord,
      }).then((data) => {
        if (data.pins) {
          return {
            pins: data.pins.filter((item) => !!item),
          };
        } else {
          return data;
        }
      });
    },
    {
      refreshDeps: [newPinId], // 只依赖 newPinId，因为 newPinId 已延迟更新
      cacheKey: `${newPinId}-${fileIds.join(",")}`,
    }
  );

  useEffect(() => {
    if (pin) {
      window.dispatchEvent(new CustomEvent(EVENT.UPDATE_PIN, { detail: pin }));
      usePinDetailStore.setState({ pin });
    }
  }, [pin]);

  // 获取同在画板匹配结果
  useEffect(() => {
    if (!pin?.pin_id || !user?.urlname) {
      // 即使没有 pin 或 user，也要设置一个空的结果对象，避免一直显示 "..."
      setBoardMatchingResult({
        recommendedBoard: null,
        recommendedBoards: [],
        recommendedRelatedBoards: [],
        useUserBoardRecommendation: false,
      });
      return;
    }

    // 如果用户画板已加载且 >= 5，立即同步设置空结果，直接显示采集至画板
    if (userBoards.length >= 5) {
      setBoardMatchingResult({
        recommendedBoard: null,
        recommendedBoards: [],
        recommendedRelatedBoards: [],
        useUserBoardRecommendation: false,
      });
      return;
    }

    const loadRelatedBoards = async () => {
      try {
        // 确保用户画板已加载，如果没有则先获取
        let currentUserBoards = userBoards;
        if (currentUserBoards.length === 0) {
          currentUserBoards = await ensureUserBoardsLoaded();

          // 加载后再次检查，如果 >= 5 个，直接显示采集至画板
          if (currentUserBoards.length >= 5) {
            setBoardMatchingResult({
              recommendedBoard: null,
              recommendedBoards: [],
              recommendedRelatedBoards: [],
              useUserBoardRecommendation: false,
            });
            return;
          }
        }

        const relatedBoards = await getSingleRelatedBoards(pin);

        const matching = getBoardMatchingForPin(
          pin,
          relatedBoards || [],
          currentUserBoards
        );

        setBoardMatchingResult(matching);
      } catch (error) {
        console.error("获取同在画板信息失败:", error);
        // 即使失败也设置一个空的结果对象
        setBoardMatchingResult({
          recommendedBoard: null,
          recommendedBoards: [],
          recommendedRelatedBoards: [],
          useUserBoardRecommendation: false,
        });
      }
    };
    loadRelatedBoards();
  }, [
    pin?.pin_id,
    user?.urlname,
    getSingleRelatedBoards,
    getBoardMatchingForPin,
    ensureUserBoardsLoaded,
    userBoards,
    pin,
  ]);

  const onToggleLike = useCallback(async () => {
    if (!user) {
      const result = await login({
        source_location: "喜欢",
      });
      if (!result) {
        return;
      }
    }
    if (!pin) {
      return;
    }
    if (pin?.liked) {
      const result = await runUnlike(pin.pin_id);
      if (!result.err) {
        setPin({
          ...pin,
          liked: false,
          like_count: pin.like_count - 1,
        });
      }
    } else {
      const result = await runLike(pin.pin_id);
      if (!result.err) {
        setPin({
          ...pin,
          liked: true,
          like_count: pin.like_count + 1,
        });
      }
    }
  }, [login, pin, runLike, runUnlike, user]);

  const onEdit = useCallback(async () => {
    await openBindTelModal();

    PinEditorModal.open({
      pinId: pin?.pin_id,
      onOk: () => {
        runReload();
      },
      onDelete: () => {
        if (isModal) {
          onClose && onClose();
          window.dispatchEvent(
            new CustomEvent(EVENT.DELETE_PIN, { detail: pin?.pin_id })
          );
        } else {
          router.push(`/boards/${pin?.board_id}`);
        }
      },
    });
  }, [isModal, onClose, pin, router, runReload]);

  const onPinSuccess = useCallback(() => {
    setPin({
      ...pin,
      repin_count: pin.repin_count + 1,
    });

    // 素材点击采集N次触发运营配置
    if (
      pin?.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE &&
      pin?.file_material?.material_category !== "其他" &&
      pin?.material_info &&
      pin?.material_info.err !== 404 &&
      !user?.vips?.length
    ) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_MATERIAL_COLLECT_TIMES
      );
    }
  }, [pin, user]);

  const onDelete = useCallback(() => {
    Modal.confirm({
      title: "删除采集",
      content: "确定要删除当前采集？",
      okText: "确定",
      cancelText: "取消",
      okButtonProps: {
        "data-gd-click": "button_click",
        "data-button-name": "确认删除采集",
        "data-content-source": "采集编辑页",
        "data-content-id": pinId,
        "data-board-id": pin?.board_id,
        "data-file-id": pin?.file_id,
        "data-material-id":
          pin?.file_material?.material_id || pin?.extra?.material_id,
        "data-unique-id": pin?.pin_id,
        "data-content-type": getContentType(pin),
      },
      onOk: async () => {
        await runDelete({ pin_id: pin?.pin_id });
        HBMessage.success("删除成功");
        if (isModal) {
          onClose && onClose();
          window.dispatchEvent(
            new CustomEvent(EVENT.DELETE_PIN, { detail: pin?.pin_id })
          );
        } else {
          router.push(`/boards/${pin.board_id}`);
        }
      },
    });
  }, [isModal, onClose, pin, router, runDelete, pinId]);
  const getCurrentPreview = (pin, pinFile, user, isMaterial) => {
    const origin = user?.user_id === pin?.user_id || !pin?.link;
    let currentPreview = {
      src: imageUrl(pinFile, {
        webp: false,
        origin,
      }),
      preview: {
        width: !origin && pinFile.width > 1200 ? 1200 : pinFile.width,
        height:
          !origin && pinFile.width > 1200
            ? Math.floor((pinFile.height * 1200) / pinFile.width)
            : pinFile.height,
        src: imageUrl(pinFile, {
          width: window.devicePixelRatio > 1 ? 1200 : 658,
        }),
      },
      pin: pin,
      pinFile,
      isMaterial,
      searchWord,
    };
    // 不支持的图片格式
    if (["image/tiff"].includes(pinFile?.type)) {
      currentPreview.src = `https://${pinFile.bucket}.huaban.com/${pinFile.key}_png`;
      currentPreview.pinFile = { ...pinFile, type: "image/png" };
    }
    return currentPreview;
  };
  // 是否是素材
  const isMaterial = useMemo(() => {
    return isMaterialPin(pin);
  }, [pin]);

  const onShowPreview = useCallback(() => {
    if (!pin) return;
    let currentPreview = getCurrentPreview(pin, pinFile, user, isMaterial);
    useAppStore.setState({ currentPreview });
    let detailsSetp = getNextDetailsSetp();
    let historyData = typeof history?.state === "object" ? history?.state : {};

    const stackElements = document.querySelectorAll("[data-stack-index]");
    const pinStack = useAppStore.getState().pinStack;
    const isFullScreenMode = pinStack.length > 0 && stackElements.length > 0;

    const historyOperationState = isFullScreenMode
      ? history.replaceState
      : history.pushState;

    historyOperationState(
      isModal
        ? {
            ...historyData,
            detailsSetp,
            viewImageSetp: 1,
            firstPinId: pin.pin_id,
            pin,
            isModal: true, // 确保设置 isModal 状态
          }
        : { ...historyData, pin },
      null,
      `/pins/${pin.pin_id}?modalImg=${encodeURIComponent(currentPreview.src)}`
    );
  }, [pin, pinFile, user, isModal, isMaterial]);

  const [prevPin, nextPin] = useMemo(() => {
    // 过滤折叠对象和非pin类型的卡片
    const pins = pinQueue.filter(
      (item) =>
        !item.folding_num &&
        item.is_private !== PIN_PRIVATE_STATUS.VIOLATION &&
        !item.type // 过滤掉所有非pin类型的卡片（如推荐广告、问卷等）
    );

    if (pins.length <= 0 || !pinId) {
      return [null, null];
    }
    let index = pins.findIndex((item) => item.pin_id === pinId);
    // 兼容画板的采集列表点击然后保留当前index位置
    if (index === -1) {
      index = indexRef.current;
    } else {
      indexRef.current = index;
    }

    return [pins[index - 1], pins[index + 1]];
  }, [pinQueue, pinId]);

  const onOperation = useCallback(
    (pin) => {
      // 下一张的时候判断当前查看大图弹窗是否打开
      let { modalImg } = qs.parse(location.search.slice(1));
      // 每次push的时候记录一下detailSetp
      let detailsSetp = getNextDetailsSetp();
      let viewImageSetp = getNextViewImageSetp();

      const stackElements = document.querySelectorAll("[data-stack-index]");
      const pinStack = useAppStore.getState().pinStack;
      const isFullScreenMode = pinStack.length > 0 && stackElements.length > 0;
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      const historyOperationState = isFullScreenMode
        ? history.replaceState
        : history.pushState;

      if (modalImg) {
        let currentPreview = getCurrentPreview(pin, pin.file, user, isMaterial);
        useAppStore.setState({
          currentPin: { pinId: pin.pin_id, searchWord },
          // currentPreview,
        });
        historyOperationState(
          isModal
            ? { ...historyData, detailsSetp, viewImageSetp, isModal: true }
            : { ...historyData },
          null,
          `/pins/${pin.pin_id}?modalImg=${encodeURIComponent(
            currentPreview.src
          )}`
        );
      } else {
        window.history.pushState(
          { ...historyData, detailsSetp },
          null,
          `/pins/${pin.pin_id}`
        );
        useAppStore.setState({ currentPin: { pinId: pin.pin_id, searchWord } });
      }
    },
    [isModal, user, isMaterial, searchWord, pinId]
  );

  // 快捷键：查看采集大图
  useKeyPress(
    SHORTCUT.FULL_IMAGE,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }
      let { modalImg } = qs.parse(location.search.slice(1));
      if (modalImg) {
        // 关闭
        // 重置currentPreview 数据
        useAppStore.setState({ currentPreview: {} });
        let detailsSetp = getNextDetailsSetp();
        let viewImageSetp = getNextViewImageSetp();
        // 判断用户有没有左右切换之后切换回原点
        let firstPinId = history?.state?.firstPinId;
        let historyData =
          typeof history?.state === "object" ? history?.state : {};

        const stackElements = document.querySelectorAll("[data-stack-index]");
        const pinStack = useAppStore.getState().pinStack;
        const isFullScreenMode =
          pinStack.length > 0 && stackElements.length > 0;
        const historyOperationState = isFullScreenMode
          ? history.replaceState
          : history.pushState;

        // 修改当前url
        historyOperationState(
          {
            ...historyData,
            detailsSetp,
            ...(location.pathname.includes(firstPinId)
              ? { viewImageSetp }
              : null),
          },
          null,
          `${location.pathname}`
        );
      } else {
        // 打开
        onShowPreview();
      }
    },
    {
      exactMatch: true,
    }
  );

  useKeyPress(
    SHORTCUT.EXIT,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      onClose && onClose();
    },
    {
      exactMatch: true,
    }
  );

  useKeyPress(
    SHORTCUT.SOURCE_URL,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (pin?.source && !pin?.domain?.hide_origin) {
        window.open(
          `/go?pin_id=${pin?.pin_id}&url=${encodeURIComponent(pin?.source)}`
        );
      }
    },
    {
      exactMatch: true,
    }
  );
  useKeyPress(
    SHORTCUT.DELETE_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (user?.user_id === pin?.user_id) {
        onDelete();
      }
    },
    {
      exactMatch: true,
    }
  );

  usePinDetailPV(pin);

  const onSelectPin = useCallback(
    (pin, currentSrc, source) => {
      const param = qs.stringify(
        {
          ...(source ? { from: source } : null),
          ...(searchWord ? { searchWord } : null),
        },
        { addQueryPrefix: true }
      );
      const pinId = pin.pin_id;
      if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
        window.open(`/pins/${pinId}${param}`);
        return;
      }
      if (isModal) {
        // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
        useAppStore.setState({ currentPin: { pinId, currentSrc, searchWord } });
        let detailsSetp = getNextDetailsSetp();
        let historyData =
          typeof history?.state === "object" ? history?.state : {};
        window.history.pushState(
          { ...historyData, detailsSetp },
          null,
          `/pins/${pinId}${param}`
        );
      } else {
        // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
        window._pinDetailCurrentSrc = currentSrc;
        router.push(`/pins/${pinId}${param}`);
      }
    },
    [isModal, pinOpenType, router, searchWord]
  );

  // 推荐内容：同在画板 和 为你推荐
  const isVideo = useMemo(() => {
    let data = pin || currentPin;
    return (
      data?.file_material?.material_category === "视频模板" ||
      data?.file_material?.material_category === "视频"
    );
  }, [pin, currentPin]);
  const isGif = useMemo(() => {
    let data = pin || currentPin;
    return data?.file?.type === "image/gif";
  }, [pin, currentPin]);

  const onReport = useCallback(async () => {
    if (!user) {
      const result = await login({
        source_location: "采集详情-举报",
      });
      if (!result) {
        return;
      }
    }

    ReportModal.open({
      reportType: "采集",
      reportPinId: pin?.pin_id,
      reportContentId: pin?.file_material?.material_id,
      reportFileId: pin?.file_id,
      pin: pin,
      contentType: getContentType(pin),
      onOk: async (values) => {
        const result = await report({
          type: "pin",
          ...values,
          id: pin?.pin_id,
        });
        if (!result.err) {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报的"
          );
        } else {
          HBMessage.success("已收到您的举报信息，我们会尽快处理的");
        }
      },
    });
  }, [login, pin, user]);

  const isBigCompany = useMemo(() => {
    return isGdMerged(user)
      ? isBigCompanyByGdVip(vips)
      : isBigCompanyByUser(user);
  }, [user, vips]);

  const showSimilarList = useMemo(() => {
    return Boolean(
      !isVideo &&
        !isGif &&
        !isBigCompany &&
        !isFont(pin) &&
        (pin?.pin_id || pinId)
    );
  }, [isVideo, isGif, isBigCompany, pinId, pin?.pin_id, pin]);

  const showStatistic = useMemo(() => {
    return user?.user_id === pin?.user_id;
  }, [user?.user_id, pin?.user_id]);

  const sideNavWidth = useSideNavWidth();

  // 计算图片自适应展示的宽高尺寸，避免大小跳动
  const renderSizeCalc = useCallback(() => {
    if (!pinFile || typeof window === "undefined")
      return { width: 0, height: 0 };

    const { width, height } = pinFile || {};

    // oss width 通过oss作图参数后的预览展示尺寸
    let previewWidth, previewHeight;
    if (width < 658) {
      previewWidth = width;
      previewHeight = height;
    } else {
      previewWidth = 658;
      previewHeight = (height * 658) / width;
    }

    if (isVideo) {
      previewWidth = pin?.material_info?.preview?.width || pinFile?.width;
      previewHeight = pin?.material_info?.preview?.height || pinFile?.height;
    }

    const sideWidth = isModal ? 0 : sideNavWidth;

    // calc(100% - 524px);
    const containerWidth = Math.min(
      Math.max(400, window.innerWidth - 524) - 24 - sideWidth,
      1200
    );
    const containerHeight =
      Math.max(728, Math.min(window.innerHeight - headerHeight - 114, 1080)) -
      48;

    const size = getContainedImageSize(
      containerWidth,
      containerHeight,
      previewWidth,
      previewHeight
    );

    if (isVideo) {
      // 处理视频尺寸小于最小尺寸的场景
      if (size.height < 680 && size.height >= size.width) {
        size.height = 680;
        size.width = 680 * (previewWidth / previewHeight);
      } else if (size.width < 400 && size.width >= size.height) {
        size.width = 400;
        size.height = 400 / (previewWidth / previewHeight);
      }
    }

    return {
      ...size,
      cardHeight: Math.max(
        728,
        (size.height || 0) + 48 + (showStatistic ? 54 : 0)
      ),
    };
  }, [
    pinFile,
    isVideo,
    isModal,
    sideNavWidth,
    headerHeight,
    showStatistic,
    pin?.material_info,
  ]);

  const [renderSize, setRenderSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setRenderSize(renderSizeCalc());

    const resize = () => {
      setRenderSize(renderSizeCalc());
    };

    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [renderSizeCalc]);

  const imageBgClass = usePngBg(pin?.file?.theme);

  const imageSize = useMemo(() => {
    return {
      width: Math.min(pinFile?.width, 658),
      height:
        (pinFile?.height * Math.min(pinFile?.width, 658)) / pinFile?.width,
    };
  }, [pinFile]);

  // 计算AIGC标签的样式
  const aigcTagStyle = useMemo(() => {
    const width = renderSize.width;
    const height = renderSize.height;
    return {
      height: `${Math.max(Math.round(Math.min(width, height) * 0.06), 18)}px`,
      left: width ? `calc(50% - ${Math.round(width / 2) - 6}px)` : "6px",
      top: height ? `calc(50% - ${Math.round(height / 2) - 6}px)` : "6px",
    };
  }, [renderSize]);

  const isArt = !!pin?.extra?.art;

  const artLink = usePinArtLink(pin);

  return (
    <div
      className={classNames([
        styles.detail,
        isModal ? styles.pt : null,
        styles.isNew,
        styles.newRecommend,
      ])}
      data-module-name={
        isArt ? "AI作品详情" : isMaterial ? "素材采集" : "普通采集"
      }
    >
      <When condition={isModal}>
        <ModalOperate
          onClose={onClose}
          nextPin={nextPin}
          prevPin={prevPin}
          onOperation={onOperation}
          top={
            isNaN(renderSize.cardHeight) ? 364 : renderSize.cardHeight / 2 + 24
          }
          isNewRecommend={true}
          hideNavButtons={isRecommendVisible}
          data-content-source="采集详情"
          data-content-id={pin?.pin_id}
          data-board-id={pin?.board_id}
          data-material-id={pin?.file_material?.material_id}
          data-file-id={pin?.file_id}
          data-content-type={getContentType(pin)}
        ></ModalOperate>
      </When>
      <If condition={notFoundPin && isModal}>
        {/* 没有找到采集，且在弹窗模式下 */}
        <Then>
          <div className={styles.notFound}>
            <HBEmpty
              image="//cdn.dancf.com/fe-assets/img/b6574f8d7ee91f21094691f3ff13d5a9.svg"
              title="Oh~抱歉，访问的采集不存在了"
              subtitle="采集有误或该采集已被删除"
            />
          </div>
        </Then>

        <Else>
          <PinHead pin={pin} isMaterial={isMaterial} />
          <div
            id="pin_detail"
            className={styles.card}
            ref={detailRef}
            data-content-source="采集详情"
            data-content-id={pin?.pin_id}
            data-board-id={pin?.board_id}
            data-material-id={pin?.file_material?.material_id}
            data-file-id={pin?.file_id}
            data-content-type={getContentType(pin)}
            style={{
              height: renderSize.cardHeight,
            }}
          >
            <div className={classNames([styles.img, styles.leftImg])}>
              <Switch>
                <Case condition={isVideo}>
                  <div
                    className={classNames([
                      styles.viewer,
                      showStatistic && styles.withStatistic,
                    ])}
                    data-gd-expose="content_expose"
                    data-content-id={pin?.pin_id}
                  >
                    <div className={styles.viewerWrap}>
                      <div
                        className={classNames([
                          styles.viewContent,
                          styles.white,
                        ])}
                      >
                        <video
                          src={pin?.file_material?.extra?.video_mask}
                          width={658} // 视频一律铺满展示
                          poster={currentSrc}
                          controls
                          loop
                          muted
                          autoPlay
                          preload="metadata"
                          controlsList="nodownload"
                          style={{
                            width: renderSize.width,
                            height: renderSize.height,
                            top: isModal
                              ? viewStickyTop
                              : headerHeight + viewStickyTop,
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Case>
                <Case condition={pinFile}>
                  <div
                    className={classNames([
                      styles.viewer,
                      showStatistic && styles.withStatistic,
                    ])}
                    data-search-word={searchWord}
                  >
                    <div className={styles.viewerWrap}>
                      <div
                        className={styles.viewContent}
                        ref={viewContentRef}
                        style={{
                          top: isModal
                            ? viewStickyTop
                            : headerHeight + viewStickyTop,
                        }}
                      >
                        {isFont(pin) ? (
                          <FontDetailPreview
                            pin={pin}
                            active={true}
                            onBackgroundClick={undefined}
                          />
                        ) : (
                          <div
                            className={styles.imageWrap}
                            style={{
                              height:
                                (pinFile?.height *
                                  Math.min(pinFile?.width, 658)) /
                                pinFile?.width,
                            }}
                          >
                            <Image
                              className={classNames([
                                imageBgClass,
                                Math.min(pinFile?.width, 658) === 658
                                  ? styles.radius
                                  : null,
                                styles.zoom,
                              ])}
                              preClassName={styles.pre}
                              key={imageUrl(pinFile, { width: 658 })}
                              src={imageUrl(pinFile, { width: 658 })}
                              srcSet={
                                imageUrl(pinFile, { width: 1200 }) + " 2x"
                              }
                              preSrc={currentSrc}
                              alt={
                                pin?.raw_text ||
                                `${pin?.board?.title}内的花瓣采集图片-${pin?.user?.username}`
                              }
                              width={imageSize.width}
                              height={imageSize.height}
                              loading={"eager"}
                              title="点击查看大图 [F]"
                              limit={true}
                              showError={true}
                              fetchpriority={"high"}
                              onClick={onShowPreview}
                              data-gd-expose="content_expose"
                              data-ignore-search="1"
                              data-content-id={pin?.pin_id}
                              data-gd-click="button_click"
                              data-button-name="查看大图"
                              crossOrigin="anonymous"
                              data-source-file-ids={fileIds}
                              style={{
                                width: renderSize.width,
                                height: renderSize.height,
                              }}
                            />
                            {/* 相似采集按钮 */}
                            <When condition={pin?.trusted !== false}>
                              <Affix
                                target={() =>
                                  isModal
                                    ? document.querySelector(".pinDetailModal")
                                    : window
                                }
                                offsetBottom={8}
                                style={{
                                  position: "absolute",
                                  bottom: "8px",
                                  left: "auto",
                                  right: "8px",
                                }}
                              >
                                {isNewSimilarButton ? (
                                  <SimilarSearchButton
                                    pin={pin}
                                    className={styles.similarSearchBtn}
                                    trackerData={{
                                      "data-search-word": searchWord,
                                      "data-pin-detail": true,
                                    }}
                                  />
                                ) : (
                                  <Button
                                    className={classNames(
                                      styles.link,
                                      styles.similarLink
                                    )}
                                    data-gd-click="button_click"
                                    data-button-name="搜索相似采集"
                                    data-search-word={searchWord}
                                    data-pin-detail
                                    href={`/similar?bucket=${
                                      pin?.file?.bucket
                                    }&key=${pin?.file?.key}${
                                      pin?.file_id
                                        ? `&file_id=${pin?.file_id}`
                                        : ""
                                    }&width=${pin?.file?.width}&height=${
                                      pin?.file?.height
                                    }`}
                                    target="_blank"
                                    rel="nofollow"
                                    data-tooltip="搜相似"
                                  >
                                    <HBIcon type="ic_search-similar1" />
                                  </Button>
                                )}
                              </Affix>
                            </When>
                            <When
                              condition={
                                pin?.source && !pin?.domain?.hide_origin
                              }
                            >
                              <Affix
                                target={() =>
                                  isModal
                                    ? document.querySelector(".pinDetailModal")
                                    : window
                                }
                                offsetBottom={8}
                                style={{
                                  position: "absolute",
                                  bottom: "8px",
                                  right: "auto",
                                  left: "8px",
                                }}
                              >
                                <a
                                  className={styles.link}
                                  title={pin?.link}
                                  target="_blank"
                                  href={`/go?pin_id=${
                                    pin?.pin_id
                                  }&url=${encodeURIComponent(pin?.source)}`}
                                >
                                  <HBIcon
                                    className={styles.icon}
                                    type={"ic_open"}
                                  />
                                  <span className={styles.text}>
                                    {"访问网站"}
                                  </span>
                                </a>
                              </Affix>
                            </When>
                            <AiTag pin={pin} showDetail style={aigcTagStyle} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Case>
              </Switch>
              {user?.user_id === pin?.user_id && (
                <div className={styles.statistic}>
                  <div>
                    <span className={styles.statisticItemTitle}>转采数</span>
                    <span className={styles.statisticItemValue}>
                      {displayNum(pin?.repin_count) || 0}
                    </span>
                  </div>

                  <div>
                    <span className={styles.statisticItemTitle}>喜欢数</span>
                    <span className={styles.statisticItemValue}>
                      {displayNum(pin?.like_count) || 0}
                    </span>
                  </div>
                  <div>
                    <span className={styles.statisticItemTitle}>采集时间</span>
                    <span className={styles.statisticItemValue}>
                      {dayjs(pin?.created_at * 1000).format("YYYY/MM/DD")}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className={styles.info} ref={rightContent}>
              <div
                className={styles.action}
                style={{ top: isModal ? 0 : headerHeight }}
                data-search-word={searchWord}
              >
                <div className={styles.left}>
                  {user?.user_id !== pin?.user_id && (
                    <>
                      <div
                        className={classNames([
                          styles.icon,
                          pin?.liked ? styles.liked : null,
                        ])}
                        onClick={onToggleLike}
                        data-gd-click="button_click"
                        data-button-name={pin?.liked ? "取消喜欢" : "喜欢"}
                        data-tooltip={pin?.liked ? "取消喜欢" : "喜欢"}
                        data-tooltip-position="bottom"
                        data-source-file-ids={fileIds}
                        style={{
                          marginRight: 0,
                        }}
                      >
                        <HBIcon
                          type={pin?.liked ? "ic_favorite" : "favorite1"}
                        />
                      </div>
                      {pin?.like_count > 0 && (
                        <div className={styles.likeCount}>
                          {displayNum(pin?.like_count, {
                            space: true,
                            thousand: true,
                            isUpper: true,
                            showPlus: false,
                            fixed: 2,
                          })}
                        </div>
                      )}
                    </>
                  )}
                  <ShareDropdown
                    placement="bottomCenter"
                    pics={imageUrl(pinFile)}
                    title="这张来自「花瓣网」的图不错哦，快来看看！"
                  >
                    <div
                      className={styles.icon}
                      data-gd-click="button_click"
                      data-button-name="分享"
                      data-source-file-ids={fileIds}
                    >
                      <HBIcon type="hb_share2" />
                    </div>
                  </ShareDropdown>

                  <PurePinMore
                    overideClassName={styles.icon}
                    pin={pin}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onReport={onReport}
                    trackerData={{
                      "data-source-file-ids": fileIds,
                    }}
                    showMeOperation
                  />
                </div>
                <div className={styles.right}>
                  <PurePinButton
                    pin={pin}
                    onOk={onPinSuccess}
                    current={true}
                    shortcutOrder={0}
                    isPinDetail
                    showTooltip
                    searchWord={searchWord}
                    boardMatchingResult={boardMatchingResult}
                    onUserBoardUpdate={updateUserBoards}
                    isNewUser={isNewUser()}
                    enableBoardRecommend={true}
                    recordOperation={
                      isFromDiscovery ? recordOperation : undefined
                    }
                    trackerData={{
                      "data-source-file-ids": fileIds,
                    }}
                  />
                </div>
              </div>
              <div className={styles.sticky} style={style} ref={stickyRef}>
                <PinTitle
                  pin={pin || currentPin}
                  setPin={setPin}
                  showSource={false}
                  showUser={!isMaterial}
                  showTooltip
                ></PinTitle>
                <Switch>
                  <Case condition={isMaterial}>
                    <PinMaterial2
                      pin={pin}
                      searchWord={searchWord}
                      recordOperation={
                        isFromDiscovery ? recordOperation : undefined
                      }
                      trackerData={{
                        "data-source-file-ids": fileIds,
                      }}
                    />
                  </Case>
                  <Case
                    condition={
                      pin?.file_material?.status ===
                      PIN_MATERIAL_STATUS.MODIFIED
                    }
                  >
                    <PinMaterialRedirect pin={pin} />
                  </Case>
                  <Case condition={pin?.file_aigc && !isArt}>
                    <PinAIInfo2
                      info={pin?.file_aigc}
                      pin={pin}
                      searchWord={searchWord}
                    />
                  </Case>
                </Switch>

                {!isArt && !isMaterial && (
                  // <NewPinDetailAiTools
                  //   pin={pin}
                  //   isMaterial={isMaterial}
                  //   searchWord={searchWord}
                  // />
                  <NormalButton pin={pin} searchWord={searchWord} />
                )}
                {isArt && (
                  <ArtButton
                    pin={pin}
                    searchWord={searchWord}
                    artLink={artLink}
                  />
                )}
                {showSimilarList && (
                  <SimilarMaterialList
                    material_id={pin?.extra?.material_id}
                    className={classNames(styles.similar, styles.noBottom)}
                    pin_id={newPinId}
                    onSelect={onSelectPin}
                    similiarList={similiarList}
                    isNew
                    searchWord={searchWord}
                    version={"old"}
                    trackerData={{
                      "data-source-file-ids": fileIds,
                    }}
                  />
                )}
              </div>
            </div>

            {pin?.file_material?.extra?.group_ids ? (
              <PinSeries
                pin={pin}
                onSelect={onSelectPin}
                isModal={isModal}
                isBlack={true}
                searchWord={searchWord}
                trackerData={{
                  "data-source-file-ids": fileIds,
                }}
              />
            ) : null}
          </div>
          {/* 推荐 */}
          <div ref={recommendRef}>
            <RecommendNew
              isModal={isModal}
              pin={pin}
              showSimilarList={showSimilarList}
              relatedBoards={relatedBoards}
              similiarList={similiarList}
              searchWord={searchWord}
              stackIndex={stackIndex}
              trackerData={{
                "data-source-file-ids": fileIds,
              }}
            />
          </div>
        </Else>
      </If>
    </div>
  );
}
